import React from "react";
import { motion } from "framer-motion";

import groupedImage from "../assets/thirdparty.png";
import integrationIcon from "../assets/integration-icon2.png";
import capabilityImage from "../assets/digital-capability.webp";
import transactionIcon from "../assets/transaction.png";
import ecommerceIcon from "../assets/ecommerce.png";
import integrationI from "../assets/integration-icon.png";
import badge1 from "../assets/thibadge1.svg";
import badge2 from "../assets/thibadge2.svg";
import badge3 from "../assets/thibadge3.svg";
import badge4 from "../assets/thibadge4.svg";
import badge5 from "../assets/thibadge5.svg";
import badge6 from "../assets/thibadge6.svg";
import badge7 from "../assets/thibadge7.svg";
import badge8 from "../assets/thibadge8.svg";
import badge9 from "../assets/thibadge9.svg";
import badge10 from "../assets/thibadge10.svg";
import badge11 from "../assets/thibadge11.svg";
import badge12 from "../assets/thibadge12.svg";
import badge13 from "../assets/thibadge13.svg";
import badge14 from "../assets/thibadge14.svg";
import { useState, useEffect,useRef } from "react";  
import { Helmet } from "react-helmet-async";

import { useNavigate } from 'react-router-dom';  


export default function ThirdPartyIntergartion() {
   
  const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };
   const navigate = useNavigate();
 
  const handleClick = () => {
    navigate("/Contact#contact-section");
  };

   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isServicesOpen, setIsServicesOpen] = useState(false);
    const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
    const [isCompanyOpen, setIsCompanyOpen] = useState(false);
  
    const toggleMobileMenu = () => {
      setIsMobileMenuOpen(!isMobileMenuOpen);
    };
  
    const toggleServicesDropdown = () => {
      setIsServicesOpen(!isServicesOpen);
    };
  
    const toggleIndustriesDropdown = () => {
      setIsIndustriesOpen(!isIndustriesOpen);
    };
  
    const toggleCompanyDropdown = () => {
      setIsCompanyOpen(!isCompanyOpen);
    };
  const badgeRows = [
    [badge1, badge2, badge3],
    [badge4, badge5, badge6],
    [badge7, badge8, badge9],
    [badge10, badge11, badge12],
    [badge13, badge14],
  ];
const features = [
    {
      icon: transactionIcon,
      title: "Transaction",
      description:
        "Integration of Lentera’s mobile apps with safe payment processors to enable smooth transactions.",
      bg: "from-[#E8FFE2] to-[#F6FFF3] border-[#C8FACC]",
    },
    {
      icon: ecommerceIcon,
      title: "E-commerce",
      description:
        "Order tracking and logistics management in real time are made possible by integrating with shipping providers.",
      bg: "from-[#FFF5E0] to-[#FFFBF2] border-[#FFE3B9]",
    },
    {
      icon: integrationIcon,
      title: "Integration",
      description:
        "Third-party services are smoothly integrated into LENTERA’s mobile apps to create a cohesive digital environment.",
      bg: "from-[#E5F4FF] to-[#F4FAFF] border-[#C3E5FA]",
    },
  ];

  const [isOpen, setIsOpen] = useState(false);

  const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <>
   <Helmet>
        <title>Expert Software Consulting Services | Accelerate Digital Transformation
</title>
        <meta name="description" content="Boost your business growth with expert software consulting. Our senior consultants provide strategic guidance, optimized systems, and flexible solutions for smarter decision-making and accelerated digital transformation."/>
        <meta name="keywords" content="IT strategy consulting, technology consulting, business technology solutions, software project management, software optimization, IT consulting experts, strategic software solutions"/>
      </Helmet>
          <section className="w-full bg-[#FAFAFA] py-20 px-4 sm:px-6">
  <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
    
    {/* Left Column – 60% with animation */}
    <motion.div
      className="w-full lg:w-[60%]"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <h5 className="text-[#07862B] text-sm font-semibold uppercase mb-3 tracking-wide">
        Third Party Integration
      </h5>

      <h2 className="text-[#1E1E1E] text-[40px] md:text-[48px] font-extrabold leading-tight mb-6">
         Seamlessly supercharge <br className="hidden sm:block" /> your systems with powerful
      </h2>

      <p className="text-[#4A4A4A] text-base leading-relaxed max-w-[580px]">
        Third-party integration connects your software to external platforms to enhance functionality,
        streamline operations, and boost overall efficiency.
      </p>
    </motion.div>

    {/* Right Column – 40% with animation */}
    <motion.div
      className="w-full lg:w-[40%] flex justify-center"
      initial={{ opacity: 0, x: 60 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
    >
      <img
        src={groupedImage}
        alt="Third Party Illustration"
        className="w-454 max-w-[400px] h-auto object-contain"
      />
    </motion.div>

  </div>
</section>

     
  
    <section className="w-full bg-white font-poppins">
      {/* Intro Section */}
      

     <section className="bg-[#e5f0ff] py-16 px-4">
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, ease: "easeOut" }}
    viewport={{ once: true }}
    className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center"
  >
    {/* LEFT IMAGE */}
    <div className="flex justify-center">
      <img
        src={integrationI}
        alt="Integration"
        className="w-[250px] sm:w-[300px] lg:w-[400px] object-contain"
      />
    </div>

    {/* RIGHT CONTENT */}
    <div>
      <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
        What is third party integration?
      </h2>
      <p className="text-lg text-gray-700">
        Third-party integration is the process of connecting external services
        or tools to your software system. It enhances capabilities without
        building features from scratch.
      </p>
    </div>
  </motion.div>

  {/* OVERVIEW BOX */}
 <motion.div
  initial={{ opacity: 0, y: 30 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.8, ease: "easeOut" }}
  viewport={{ once: true }}
  className="bg-[#e5f0ff] py-12 px-4"
>
  <div className="max-w-6xl mx-auto">
    <div className="relative bg-white rounded-[40px] shadow-md px-6 sm:px-10 py-8 flex flex-col lg:flex-row items-start gap-6 lg:gap-10 overflow-hidden">

      {/* Background Emoji-style Decorations */}
      {/* <span className="absolute top-5 left-8 w-[24px] h-[24px] bg-[#FFE3E3] rounded-full z-0" />
      <span className="absolute top-16 left-6 w-[90px] h-[40px] bg-[#F4F4F4] rounded-xl z-0" />
      <span className="absolute bottom-6 left-12 w-0 h-0 border-l-[10px] border-r-[10px] border-t-[18px] border-transparent border-t-[#FFECB3] z-0 rotate-45" />
      <span className="absolute top-12 left-[90px] w-[96px] h-[36px] bg-[#EEFFF4] rounded-md z-0" /> */}

      {/* LEFT SIDE: OVERVIEW Text */}
      <div className="relative z-10 flex flex-col justify-center top-[10px] w-full lg:w-[200px] pt-4">
        <div className="text-[20px] sm:text-[22px] font-bold text-[#111] tracking-wide">
          OVERVIEW
        </div>
      </div>

      

      {/* RIGHT SIDE: PARAGRAPH */}
<div className="relative z-10 border-l border-gray-300 pl-6 text-gray-700 text-base leading-relaxed">
      In our company, third-party integration allows smooth incorporation of
      external software and APIs. It helps us add advanced features quickly
      without lengthy development. This boosts efficiency, encourages innovation,
      and speeds up time-to-market. Collaborating with top providers keeps our
      digital services competitive and flexible.
    </div>
    </div>
  </div>
</motion.div>

</section>

      {/* Digital Capability */}
       <section className="py-16 px-4 flex justify-center bg-white">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true }}
        className="bg-[#F8F8F8] w-[1312px] rounded-[40px] px-10 lg:px-16 py-14 flex flex-col lg:flex-row items-center gap-10 shadow-sm"
      >
        {/* Left Content */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.9, delay: 0.1 }}
          viewport={{ once: true }}
          className="w-full lg:w-1/2"
        >
          <h2 className="text-[36px] lg:text-[44px] font-bold text-[#1A1A1A] leading-tight mb-4">
            Digital capability via<br />integration
          </h2>
          <div className="w-[84px] h-[3px] bg-[#3DBE83] mb-6" />
          <p className="text-[#333] text-[17px] leading-relaxed mb-5">
            By integrating services like analytics platforms, CRM systems, and payment gateways,
            third-party integration at LENTERA improves our digital capabilities. This method
            guarantees faultless user experiences while enhancing scalability, backend efficiency,
            and dependability.
          </p>
          <p className="text-[#333] text-[17px] leading-relaxed">
            By utilizing outside expertise, we modify our solutions to satisfy changing industry norms
            and customer demands, showcasing LENTERA's dedication to innovation and meeting and
            surpassing customer expectation.
          </p>
        </motion.div>

        {/* Right Image */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.9, delay: 0.2 }}
          viewport={{ once: true }}
          className="w-full lg:w-1/2 flex justify-center"
        >
          <img
            src={capabilityImage}
            alt="Digital Capability"
            className="w-full max-w-[460px] object-contain"
          />
        </motion.div>
      </motion.div>
    </section>

      {/* Badges Section */}
     

{/* Software Consulting Section */}
<section className="px-4 py-16 font-[Poppins] max-w-[1240px] mx-auto text-center relative">
  <motion.h2
    className="text-3xl sm:text-4xl xl:text-[42px] font-bold text-[#0F0F0F] mb-4"
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
    viewport={{ once: true }}
  >
    Benefits of our software<br />consulting
  </motion.h2>

  <motion.p
    className="text-base text-[#4D4D4D] max-w-[640px] mx-auto mb-10"
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5, delay: 0.2 }}
    viewport={{ once: true }}
  >
    Unlock strategic growth and technical excellence with our expert software consulting.
  </motion.p>

 <div className="relative flex flex-col lg:flex-row items-start justify-start gap-6">
  {/* FEATURES LABEL + VERTICAL LINE */}
  <div className="hidden lg:flex flex-col items-center justify-center ml-4">
  <div className="flex flex-row items-center gap-2 translate-x-[120px]">
    {/* Rotated Text */}
    <div className="rotate-[-90deg] text-size-[40px] text-sm font-semibold text-[#0F0F0F] tracking-widest">
      FEATURES
    </div>
    {/* Vertical Line on Right */}
    <div className="w-[1px] h-[320px] bg-[#D9D9D9]" />
  </div>
</div>



  {/* BADGES GRID */}
  <div className="pl-0 lg:pl-[80px] flex flex-col gap-4 w-full">
    {badgeRows.map((row, rowIndex) => (
      <motion.div
        key={rowIndex}
        className="flex flex-wrap justify-center gap-4"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: rowIndex * 0.2 }}
        viewport={{ once: true }}
      >
        {row.map((badge, colIndex) => (
          <img
            key={colIndex}
            src={badge}
            alt={`badge-${rowIndex}-${colIndex}`}
            className="h-[52px] w-auto"
          />
        ))}
      </motion.div>
    ))}
  </div>
</div>

</section>

{/* Key Features Section */}
<section className="bg-[#f9f9f9] py-16 px-4 text-center font-poppins">
      <div className="max-w-[1312px] mx-auto">
        {/* Title */}
        <motion.h2
          className="text-3xl sm:text-4xl font-bold text-[#0F0F0F] mb-4"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          Key features
        </motion.h2>

        {/* Subtitle */}
        <motion.p
          className="text-[#3D3D3D] text-base sm:text-lg mb-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          viewport={{ once: true }}
        >
          Uncover the standout features that drive your business ahead of the competition
        </motion.p>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((item, index) => (
            <motion.div
              key={index}
              className={`rounded-[20px] border ${item.bg} bg-gradient-to-b shadow-sm px-8 py-10 transition-transform hover:scale-105`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <img
                src={item.icon}
                alt={item.title}
                className="w-[56px] h-[56px] mx-auto mb-6"
              />
              <h3 className="text-[20px] font-semibold text-[#0F0F0F] mb-3">
                {item.title}
              </h3>
              <p className="text-[#3D3D3D] text-[16px] leading-relaxed">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>

    </section>
     
    </>
  );
}
